module.exports = __webpack_public_path__ + "img/btn_eng_stop.084a2ca2.jpg";